export enum BlogsWorkspaceCapabilityUdoTemplateKey {
    blog = "72a7d738-ae1e-42de-8203-04d4a8532684",
}
